import React from "react";
import loadingModalStyles from './LoadingModalContent.module.scss';

type LoadingModalContentProps = {
  title?: string | JSX.Element,
  subtitle?: string | JSX.Element,
  actionButton?: JSX.Element | JSX.Element[]
}

export default function LoadingModalContent({title = "Please wait...", subtitle, actionButton}: LoadingModalContentProps) {
  return <div className={loadingModalStyles.container}>
    <i className={`fa-regular fa-spinner fa-spin ${loadingModalStyles.spinner}`}/>
    {typeof title === "string" ? <h5 className={`mb-0 ${loadingModalStyles.title}`}>{title}</h5> : title}
    {typeof subtitle === "string" ? <p className={`mt-2 mb-0 ${loadingModalStyles.infoText}`}>{subtitle}</p> : subtitle}
    {!!actionButton && actionButton}
  </div>;
}

export { loadingModalStyles }
